// extracted by mini-css-extract-plugin
export default {"as":"index_as__0c0by"};